// extracted by mini-css-extract-plugin
export default {"page":"_PageLayout_page__OuyAy","hasHeader":"_PageLayout_hasHeader__Cq57v","hasSidebar":"_PageLayout_hasSidebar__L3bJe","hasStickyFooter":"_PageLayout_hasStickyFooter__30mo7"};